export default __webpack_public_path__ + "static/triggered-spotlight-dark-b51f8f9a76bc41b3ebfa95323714b7c50e71b4e28dfe217f9741d7d27d89dac2.png";